import apiClient from './client';

export interface PickupPerson {
  id: string;
  guardian_id: string;
  name: string;
  phone: string;
  relationship_label: string;
  photo_url: string;
  emergency_contact_name: string;
  emergency_contact_phone: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface PickupPersonInput {
  name: string;
  phone: string;
  relationship_label: string;
  emergency_contact_name: string;
  emergency_contact_phone: string;
}

export const pickupPersonsApi = {
  list: (): Promise<PickupPerson[]> =>
    apiClient.get('/pickup-persons/').then((r) => r.data),
  create: (data: PickupPersonInput, photoFormData: FormData): Promise<PickupPerson> => {
    photoFormData.append('name', data.name);
    photoFormData.append('phone', data.phone);
    photoFormData.append('relationship_label', data.relationship_label);
    photoFormData.append('emergency_contact_name', data.emergency_contact_name);
    photoFormData.append('emergency_contact_phone', data.emergency_contact_phone);
    return apiClient.post('/pickup-persons/', photoFormData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data);
  },
  update: (id: string, data: Partial<PickupPersonInput> & { is_active?: boolean }): Promise<PickupPerson> =>
    apiClient.put(`/pickup-persons/${id}`, data).then((r) => r.data),
  remove: (id: string): Promise<void> =>
    apiClient.delete(`/pickup-persons/${id}`).then(() => undefined),
  uploadPhoto: (id: string, formData: FormData): Promise<PickupPerson> =>
    apiClient.post(`/pickup-persons/${id}/photo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((r) => r.data),
};